import React from 'react';
import { Button } from '@missionlabs/smartagent-app-components';
import { FormTitle, Loader } from 'components';
import CrossIcon from 'images/icon-cross.svg';
import styles from './FormHeader.module.scss';

interface Props {
    onClose: () => void;
    onSubmit?: () => void;
    isSubmitDisabled?: boolean;
    showLoader?: boolean;
    title?: string;
}

const FormHeader = ({
    onClose,
    onSubmit,
    isSubmitDisabled,
    showLoader,
    title,
}: Props) => {
    return (
        <div className={styles.header}>
            <Button type="button" className={styles.cross} onClick={onClose}>
                <img src={CrossIcon} alt="Close" />
            </Button>
            <FormTitle className={styles.title} title={title ?? 'Edit Contact Endpoint'} />
            <div className={styles.controls}>
                <Button
                    styling="simple"
                    type="button"
                    className={styles.button}
                    onClick={onClose}
                >
                    Cancel
                </Button>
                <Button
                    styling="primary"
                    className={styles.button}
                    onClick={onSubmit}
                    disabled={isSubmitDisabled}
                >
                    {showLoader ? (
                        <Loader
                            className={styles.loader}
                            backgroundClassName={styles['loader--background']}
                            disableBackground
                        />
                    ) : (
                        'Save'
                    )}
                </Button>
            </div>
        </div>
    );
};

export default FormHeader;
